"use strict";

(function () {
  "use strict";

  Error.stackTraceLimit = Math.max(100, Error.stackTraceLimit || 0);
  const reStackEntry = /\s+at\s/;
  function splitErrorStack(error) {
    if (!error) return {
      message: "Unknown error",
      lines: []
    };
    if (!error.stack) return {
      message: error.message,
      lines: []
    };
    const lines = error.stack.split("\n");
    const index = lines.findIndex(line => reStackEntry.test(line));
    const message = lines.slice(0, index).join("\n");
    return {
      message,
      lines: lines.slice(index)
    };
  }
  function mergeErrors(traceError, mainError) {
    var _traceLines$;
    const {
      lines: traceLines
    } = splitErrorStack(traceError);
    const {
      lines: errorLines,
      message
    } = splitErrorStack(mainError);
    if ((_traceLines$ = traceLines[0]) !== null && _traceLines$ !== void 0 && _traceLines$.includes("at new TraceablePromise")) {
      traceLines.shift();
      const ignore = ["at Function.reject (<anonymous>)", "at Promise.__proto__.constructor.reject"];
      if (ignore.some(test => {
        var _traceLines$2;
        return (_traceLines$2 = traceLines[0]) === null || _traceLines$2 === void 0 ? void 0 : _traceLines$2.includes(test);
      })) traceLines.shift();
    }
    traceLines.reverse();
    errorLines.reverse();
    let i = 0;
    for (; i < errorLines.length && i < traceLines.length && errorLines[i] === traceLines[i]; ++i);
    return {
      message,
      promiseAt: traceLines.slice(i).reverse().join("\n"),
      errorAt: errorLines.slice(i).reverse().join("\n"),
      sharedTrace: errorLines.slice(0, i).reverse().join("\n")
    };
  }
  function defaultLogger(msg) {
    console.error(msg);
  }
  let loggerFunction = defaultLogger;
  function setLogger(loggerFn) {
    loggerFunction = loggerFn !== null && loggerFn !== void 0 ? loggerFn : defaultLogger;
  }
  function logger(reason, promise) {
    let pid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : void 0;
    const metadata = promise.__tracedError ? mergeErrors(promise.__tracedError, reason) : {
      message: (reason === null || reason === void 0 ? void 0 : reason.stack) || "Unknown stack",
      promiseAt: "N/A",
      errorAt: "N/A",
      sharedTrace: "N/A"
    };
    const prefix = pid == null ? "" : "(node:".concat(pid, ") ");
    const logMessage = "".concat(prefix, "UnhandledPromiseRejectionWarning\n") + (!promise.__tracedError ? "" : "[ Stacktrace altered by " + "https://github.com/grantila/trace-unhandled ]\n") + metadata.message;
    loggerFunction(logMessage);
    if (typeof Bugsnag !== "undefined") {
      if (metadata.promiseAt.includes("recaptcha__en.js")) {
        return;
      }
      Bugsnag.notify(reason instanceof Error ? reason : new Error("Unhandled rejection: ".concat(reason)), event => {
        event.addMetadata("TraceablePromise", {
          "Promise at": metadata.promiseAt,
          "Error at": metadata.errorAt,
          "Shared trace": metadata.sharedTrace,
          "Original reason": typeof reason === "object" ? JSON.stringify(reason) : reason
        });
      });
    }
  }
  const state = {
    resolve: null,
    reject: null
  };
  class TraceablePromise extends Promise {
    constructor(executor) {
      super(wrappedExecutor);
      function wrappedExecutor(resolve, reject) {
        state.resolve = resolve;
        state.reject = reject;
      }
      const resolve = state.resolve;
      const reject = state.reject;
      state.resolve = null;
      state.reject = null;
      const err = new Error("Non-failing tracing error");
      this.__tracedError = err;
      try {
        executor(resolve, reject);
      } catch (err) {
        reject(err);
      }
    }
  }
  window.onunhandledrejection = function (event) {
    logger(event.reason, event.promise);
  };
  window.Promise = TraceablePromise;
  window.setTraceUnhandledLogger = setLogger;
})();
//# sourceMappingURL=trace-unhandled-promises.js.map